import { render, staticRenderFns } from "./create_result.vue?vue&type=template&id=4c2bc96a&"
import script from "./create_result.vue?vue&type=script&lang=js&"
export * from "./create_result.vue?vue&type=script&lang=js&"
import style0 from "./create_result.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports